import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const PlayIcon = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, stroke, strokeOpacity, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg ref={ref} {...props} viewBox="0 0 24 24">
          <path d="M4 22V2L20 12L4 22Z" fill="currentcolor" />
          <path
            d="M3.5 22V22.9021L4.265 22.424L20.265 12.424L20.9434 12L20.265 11.576L4.265 1.576L3.5 1.09788V2V22Z"
            stroke={stroke}
            strokeOpacity={strokeOpacity}
          />
        </svg>
      </Icon>
    );
  },
);

PlayIcon.displayName = "PlayIcon";
